module.exports = __webpack_public_path__ + "media/images/logos/logo-mindset-4b368f1a44fb6e377ef6175224dcdb24.svg";